import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import DDOption from '../models/DropdownModels';
import axios from 'axios';
import { getStorageValues } from '../CommonFunctions';
import { getApiBaseUrl } from '../../utils/apiConfig';


function UsersDropdown({ onChangeDropdown, required, modelName, selectedValue, isDisable,showLabel }) {
    const [selectedUsersOption, setSelectedUsersOption] = useState([]);
    const [getUsersOptions, setUsersOptions] = useState(new DDOption() || []);
    let labelHtml;
    if(showLabel === undefined){
        labelHtml = 
                <label className="form-label">
                    Assignee { required === true ? <span style={{ color: "red" }}>*</span> : "" }
                </label>
    } else {    
        if(showLabel === true){
            labelHtml = 
                <label className="form-label">
                    Assignee { required === true ? <span style={{ color: "red" }}>*</span> : "" }
                </label>
        } 
    }
    function handleChange(e, actionMeta) {
        setSelectedUsersOption(e);
        onChangeDropdown(e, actionMeta);
    };

    const fetchUsers = async () => {
        try {
            let statusDetails = {
                UserId: getStorageValues('userId')
            };
            const response = await axios.get(getApiBaseUrl() + "/userlist", {params: statusDetails});
            if (response.status === 200) {
                setUsersDropdownData(response.data.data[0]);
            }
        } catch (error) {
            console.log(error);
        }
    };

    function setUsersDropdownData(cct) {
        let allModuleOpt = [];
        allModuleOpt = cct.map(p => ({ value: p.Id, label: p.FullName, name: 'User', description: p.Discription, isFixed: false, isDisabled: false, groupId: null }))
        setUsersOptions(allModuleOpt);
        setSelectedUsersOption(allModuleOpt.filter(x => x.value === selectedValue));
    }

    useEffect(() => {
        fetchUsers();
    }, []);
    return (
        <div className="col-12">
            <div className="mb-3">
                {labelHtml}
                <Select
                    name={modelName}
                    value={selectedUsersOption ? selectedUsersOption : []}
                    isClearable={true}
                    options={getUsersOptions || []}
                    onChange={handleChange}
                    isDisabled = {isDisable}
                    menuPlacement="auto"
                    menuPortalTarget={document.body}
                    styles={{
                        menuPortal: base => ({ ...base, zIndex: 9999 })  // ensure it's above table
                    }}
                />
            </div>
        </div>
    )
}

export default UsersDropdown